import request from '@utils/request';

export function getClassesCate() {
    return request.get('classes/cates', {}, { login: false });
}
/**
 * 获取班级列表
 * @param {*} q
 * @returns
 */
export function getClassesLists(q) {
    return request.get('classes/lists', q, { login: false });
}
/**
 * 课程详情
 * @param {*} id
 * @returns
 */
export function getClassesInfo(id) {
    return request.get('classes/info/' + id, {}, { login: false });
}
/**
 * 报名
 * @param {*} id
 * @returns
 */
export function applyClasses(id) {
    return request.post('classes/apply/' + id);
}
/**
 * 课程信息
 * @param {*} id
 * @returns
 */
export function getClassesCourse(id) {
    return request.get('classes/course/' + id);
}
